import {
  MESSAGETEMPLATEDATA,
  TEMPLATEDATA,
  SETTITLEDATA,
  SETPHONEMESSAGEDATA,
  SETSMSMESSAGEDATA,
  SETEMAILMESSAGEDATA,
  SETLANGUAGEDATA,
  SETENGLISHPOSITIVERESPONSEDATA,
  SETENGLISHNEGATIVERESPONSEDATA,
  SETSPANISHPOSITIVERESPONSEDATA,
  SETSPANISHNEGATIVERESPONSEDATA,
  FETCH,
  FETCH2,
} from './actionType'

// initialState shows what we are going to change
const initialState = {
  inputAddEntryData: '',
  data: null,
  // API call
  fetching: false,
  fetching2: false,
  inputTitleData: '',
  inputPhoneMessageData: '',
  inputSMSMessageData: '',
  inputEmailMessageData: '',
  inputLanguageData: null,
  inputEnglishPositiveResponseData: '',
  inputEnglishNegativeResponseData: '',
  inputSpanishPositiveResponseData: '',
  inputSpanishNegativeResponseData: '',
}

// Checks the type of the action and returns the appropriate state
export default function messageTemplateCreateReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case FETCH:
      // Boolean describing if the data is being gathered
      return Object.assign({}, state, {
        fetching: action.fetching,
      })
    case FETCH2:
      // Boolean describing if the data is being gathered
      return Object.assign({}, state, {
        fetching: action.fetching2,
      })
    case MESSAGETEMPLATEDATA:
      // Populate Message Template
      return Object.assign({}, state, {
        data: action.data,
      })
    case TEMPLATEDATA:
      // Update to Message Template List, either add or remove
      return Object.assign({}, state, {
        inputAddEntryData: '',
        data: action.data,
      })
    case SETTITLEDATA:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputTitleData: action.data,
      })
    case SETPHONEMESSAGEDATA:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputPhoneMessageData: action.data,
      })
    case SETSMSMESSAGEDATA:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputSMSMessageData: action.data,
      })
    case SETEMAILMESSAGEDATA:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputEmailMessageData: action.data,
      })
    case SETLANGUAGEDATA:
      return Object.assign({}, state, {
        inputLanguageData: action.data,
      })
    case SETENGLISHPOSITIVERESPONSEDATA:
      return Object.assign({}, state, {
        inputEnglishPositiveResponseData: action.data,
      })
    case SETENGLISHNEGATIVERESPONSEDATA:
      return Object.assign({}, state, {
        inputEnglishNegativeResponseData: action.data,
      })
    case SETSPANISHPOSITIVERESPONSEDATA:
      return Object.assign({}, state, {
        inputSpanishPositiveResponseData: action.data,
      })
    case SETSPANISHNEGATIVERESPONSEDATA:
      return Object.assign({}, state, {
        inputSpanishNegativeResponseData: action.data,
      })
    default:
      // returns state as is without changes
      return state
  }
}
